
// Import module styles.
import "./selectExercise.view.less";

// Import application modules.
import searchHelper from "/main/js/utils/searchHelper";

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

// Define controllers.
window.mhm2qa = {
	FormController
};

// Todo: this isn't how Alpine.js components work, I'm just trying to get rid of inline
// script tags. Will need to refactor this later.
function FormController() {

	var selectRecentLink = document.querySelector( ".select-recent" );
	var searchInput = document.querySelector( ".search-bar__input" );
	var searchClear = document.querySelector( ".search-bar__button" );
	var movementInputs = document.querySelectorAll( "input[name='movementKind']" );
	var movementKind = null;

	var searchTargets = Array
		.from( document.querySelectorAll( ".search-target" ) )
		.map(
			( node ) => {

				return({
					node: node,
					keywords: searchHelper.normalizePipeText( node.dataset.keywords )
				});

			}
		)
	;

	searchInput.addEventListener( "input", handleSearchInput );
	searchClear.addEventListener( "click", handleSearchClear );

	for ( var node of movementInputs ) {

		node.addEventListener( "input", handleMovementInput );

	}


	setMovementKind();
	handleSearchInput();

	function setMovementKind() {

		movementKind = null;

		for ( var node of movementInputs ) {

			if ( node.checked ) {

				movementKind = node.value;

			}

		}

	}


	function handleMovementInput( event ) {

		setMovementKind();
		handleSearchInput();
		updateSelectRecent();

	}

	function handleSearchInput() {

		var keywords = searchHelper.normalizeText( searchInput.value );

		for ( var target of searchTargets ) {

			var isMatch = (
				searchHelper.isFuzzyMatchMulti( target.keywords, keywords ) &&
				isMovementMatch( target )
			);

			target.node.hidden = ! isMatch;

		}

	}

	function handleSearchClear() {

		searchInput.value = "";
		handleSearchInput();

	}

	function isMovementMatch( target ) {

		return(
			( movementKind === "all" ) ||
			( ( movementKind === "push" ) && ( target.node.dataset.isPush === "yes" ) ) ||
			( ( movementKind === "pull" ) && ( target.node.dataset.isPull === "yes" ) ) ||
			( ( movementKind === "legs" ) && ( target.node.dataset.isLegs === "yes" ) )
		);

	}

	function updateSelectRecent() {

		var url = new window.URL( selectRecentLink.href );
		url.searchParams.set( "movementKind", movementKind );

		selectRecentLink.href = url.toString();

	}

}
